import React from 'react';
import { motion } from 'framer-motion';
import { FileText, UserCheck, FileSignature, ShieldAlert, Briefcase, Coins, Gavel } from 'lucide-react';
const services = [{
  icon: <FileText size={24} strokeWidth={1.5} data-id="element-131" data-mp="1dtsn4qrh970u" />,
  title: 'Повістки (до та після отримання)',
  description: 'Консультації щодо правомірності вручення, аналіз документів та алгоритм дій у разі отримання повістки.'
}, {
  icon: <FileSignature size={24} strokeWidth={1.5} data-id="element-132" data-mp="13wmsj8jnmxvv" />,
  title: 'Відстрочки від мобілізації',
  description: 'Аналіз підстав, збір необхідного пакета документів та повний супровід подання заяви до ТЦК та СП.'
}, {
  icon: <Briefcase size={24} strokeWidth={1.5} data-id="element-133" data-mp="u3z0er3mdi3h" />,
  title: 'Бронювання працівників',
  description: 'Юридичний супровід процедури бронювання військовозобов’язаних працівників для підприємств.'
}, {
  icon: <UserCheck size={24} strokeWidth={1.5} data-id="element-134" data-mp="g6ac19acfsto" />,
  title: 'Проходження ВЛК',
  description: 'Консультації щодо проходження військово-лікарської комісії та підготовка медичних документів.'
}, {
  icon: <ShieldAlert size={24} strokeWidth={1.5} data-id="element-135" data-mp="3b2xy1ts4v7mk" />,
  title: 'Оскарження рішень ТЦК та ВЛК',
  description: 'Юридичний супровід процедури оскарження висновків ВЛК та неправомірних рішень ТЦК у вищих інстанціях або суді.'
}, {
  icon: <Coins size={24} strokeWidth={1.5} data-id="element-136" data-mp="32bnsf43u7l1i" />,
  title: 'Соціальні виплати',
  description: 'Допомога в отриманні пенсій, індексацій, належних виплат та грошового забезпечення для військовослужбовців.'
}, {
  icon: <Gavel size={24} strokeWidth={1.5} data-id="element-137" data-mp="3tzy18f27tsbb" />,
  title: 'Супровід у ТЦК та суді',
  description: 'Фізичний супровід адвоката в ТЦК, представництво інтересів у суді та захист у кримінальних провадженнях.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-138" data-mp="24m2okuu61zlx">
      <div className="max-w-7xl mx-auto px-6" data-id="element-139" data-mp="29m76mpaq32e9">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-140" data-mp="29n8l73qy670q">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-141" data-mp="1pjujxgbc9ci5">
            Наші послуги
          </h2>
          <p className="text-secondary text-lg" data-id="element-142" data-mp="1lhz6xek1paoj">
            Надаємо кваліфіковану правову допомогу з усіх питань військового права
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-143" data-mp="1gpo7sdx4psx1">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-background rounded-3xl border border-border p-8 hover:border-primary/30 transition-colors duration-300 flex flex-col h-full" data-id="element-144" data-mp="1bqv237o3367f" data-mpi={index}>
              <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-145" data-mp="2n8e2ksaa4v2a">
                {service.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3" data-id="element-146" data-mp="34h6yc15pj5qy">{service.title}</h3>

              <p className="text-secondary text-sm leading-relaxed mb-8 flex-grow" data-id="element-147" data-mp="34j9tezlpvp2j">
                {service.description}
              </p>

              <a href="#contact" className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center justify-center text-sm mt-auto" data-id="element-148" data-mp="2bt1d7daqreql">
                Безкоштовна консультація
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}